export class FilterOptionsData {
  static get conditionList() {
    return [
      {
        label: "Any",
        isSelected: true,
      },
      {
        label: "New",
        isSelected: false,
      },
      {
        label: "Pre-owned",
        isSelected: false,
      },
      {
        label: "Certified pre-owned",
        isSelected: false,
      },
    ];
  }

  static get makeList() {
    return [
      {
        label: "Toyota",
        isSelected: true,
      },
      {
        label: "Nissan",
        isSelected: true,
      },
      {
        label: "Lexus",
        isSelected: true,
      },
    ];
  }

  static get bodyStyleList() {
    return [
      {
        label: "Any",
        isSelected: true,
      },
      {
        label: "Sedan",
        isSelected: false,
      },
      {
        label: "SUV",
        isSelected: false,
      },
      {
        label: "Van",
        isSelected: false,
      },
      {
        label: "Minivan",
        isSelected: false,
      },
      {
        label: "Pickup",
        isSelected: false,
      },
      {
        label: "Coup",
        isSelected: false,
      },
      {
        label: "Hatchback",
        isSelected: false,
      },
    ];
  }

  static get yearList() {
    return [
      {
        label: "2024",
        isSelected: true,
      },
      {
        label: "2023",
        isSelected: false,
      },
      {
        label: "2022",
        isSelected: false,
      },
      {
        label: "2021",
        isSelected: false,
      },
      {
        label: "2020",
        isSelected: false,
      },
      {
        label: "2019",
        isSelected: false,
      },
      {
        label: "2018",
        isSelected: false,
      },
      {
        label: "2017",
        isSelected: false,
      },
    ];
  }

  static get exteriorInteriorList() {
    return [
      {
        label: "Any",
        isexteriorSelected: true,
        isInteriorSelected: true,
      },
      {
        label: "Red",
        isexteriorSelected: false,
        isInteriorSelected: false,
      },
      {
        label: "White",
        isexteriorSelected: false,
        isInteriorSelected: false,
      },
      {
        label: "Black",
        isexteriorSelected: false,
        isInteriorSelected: false,
      },
      {
        label: "Gray",
        isexteriorSelected: false,
        isInteriorSelected: false,
      },
      {
        label: "Brown",
        isexteriorSelected: false,
        isInteriorSelected: false,
      },
    ];
  }
}
